module.exports = __webpack_public_path__ + "assets/img/36_1509.120965b2.jpg";